/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

/**
 * Login Required Page.
 *
 */

import {Component, Vue} from 'vue-property-decorator';
import pkce from '@/services/pkce';
import {Action} from 'vuex-class';


@Component({
    name: 'v-login-required',
})

export default class LoginRequired extends Vue {
    // Page Title
    @Action('updatePageTitle', {namespace: 'settingsModule'})
    public updatePageTitle!: (title: string) => void;

    // Update current view name in state
    @Action('updateCurrentView', {namespace: 'userSessionModule'})
    public updateCurrentView!: (view: {name: string, params?: any} | undefined) => void;

    /**
     * Mounted life-cycle event.
     *
     * Initialises the loader.
     */
    public async mounted(): Promise<void> {
        // Update current view name in state
        this.updateCurrentView({name: this.$route.params.name});

        // Set the page title
        // todo pageTitle - if already in loginRequired page the title doesn't update
        let pageTitle: string = '';
        const routeName: string = this.$route.params.name;

        // If there is no param name (ex. in case of refresh) then go to home page
        if (routeName === undefined) {
            this.$router.push('/');
        }

        // Show the pageTitle of the page you want to navigate to
        switch (routeName) {
            case 'report-issue': {
                pageTitle = this.$i18n.translate('menu.header.reportIssue', {}) || '';
                break;
            }
            case 'my-issues': {
                pageTitle = this.$i18n.translate('menu.header.myIssues', {}) || '';
                break;
            }
            default: {
                pageTitle = this.$i18n.translate('menu.header.title', {}) || '';
                break;
            }
        }

        this.updatePageTitle(pageTitle);

    }

    /**
     * Login action event
     */
    public loginUser(): void {
        window.location.href = pkce.getAuthUrl();
    }

}
